import { Grid } from '@mui/material';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { ISelect, ParamEnum } from '../../../../../../../shared/types/shared';
import { asyncGetLabelParams } from '../../../../../../../services/param.service';
import FieldText from '../../../../../../components/general/fields/fieldText';
import AutocompleteField from '../../../../../../components/general/fields/autocompleteField';
import LoadingButtonGeneral from '../../../../../../components/general/buttons/loadingButtonGeneral';
import { InteractionsFilters } from '../hooks/useInteractionsData';

type Props = {
    initialValues: InteractionsFilters;
    onSubmit: (values: InteractionsFilters) => void;
    onSearch: () => void;
    onReset?: () => void;
    identificationDisabled?: boolean;
    submitting?: boolean;
};

const Schema = Yup.object().shape({
    identification: Yup.string().optional(),
    plate: Yup.string().optional(),
    policy: Yup.string().optional(),
    channelId: Yup.string().optional(),
});

export const PqrFilters = ({
    initialValues,
    onSubmit,
    onSearch,
    onReset,
    identificationDisabled = false,
    submitting = false,
}: Props) => {
    const [channels, setChannels] = useState<ISelect[]>([]);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_RECEPTION_CHANNEL).then(setChannels);
    }, []);

    const formik = useFormik<InteractionsFilters>({
        initialValues,
        validationSchema: Schema,
        enableReinitialize: true,
        onSubmit: (vals) => {
            onSubmit(vals);
            onSearch();
        },
    });

    return (
        <Grid container spacing={2} mt={1}>
            <Grid item xs={12} md={3}>
                <FieldText
                    label="Identificación"
                    name="identification"
                    value={formik.values.identification || ''}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={identificationDisabled}
                    errors={formik.errors.identification}
                    touched={formik.touched.identification}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <FieldText
                    label="Placa"
                    name="plate"
                    value={formik.values.plate || ''}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.plate}
                    touched={formik.touched.plate}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <FieldText
                    label="Póliza"
                    name="policy"
                    value={formik.values.policy || ''}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.policy}
                    touched={formik.touched.policy}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <AutocompleteField
                    label="Canal PQR"
                    name="channelId"
                    data={channels}
                    value={formik.values.channelId || ''}
                    onChangeValue={(val) => {
                        formik.setFieldValue('channelId', val);
                    }}
                />
            </Grid>

            <Grid item xs={12} md={3} display="flex" alignItems="end" gap={1}>
                <LoadingButtonGeneral
                    title="Buscar"
                    onClick={() => formik.handleSubmit()}
                    loading={submitting}
                />
                <LoadingButtonGeneral
                    title="Limpiar"
                    variant="outlined"
                    onClick={() => {
                        formik.resetForm();
                        onReset?.();
                    }}
                />
            </Grid>
        </Grid>
    );
};
